/// <amd-module name="Test/Analytics/Common/Utils/TcmPerfScenarios" />
export const Area = "TestManagement";
export const TextAX_FiltersMetaData_Branch = "VSO.TFS.TCM.TextAX_FiltersMetaData_Branch";
export const TextAX_FiltersMetaData_Environment = "VSO.TFS.TCM.TestAX_FiltersMetaData_Environment";
export const TextAX_FiltersMetaData_TestRun = "VSO.TFS.TCM.TestAX_FiltersMetaData_TestRun";
export const TextAX_FiltersMetaData_Container = "VSO.TFS.TCM.TestAX_FiltersMetaData_Container";
export const TextAX_FiltersMetaData_Owner = "VSO.TFS.TCM.TestAX_FiltersMetaData_Owner";
export const TestAX_FiltersMetaData_ReleaseDefinition = "VSO.TFS.TCM.TestAX_FiltersMetaData_ReleaseDefinition";
export const TestAX_FiltersMetaData_ReleaseDefinitionFromBuildArtifact = "VSO.TFS.TCM.TestAX_ReleaseDefinitionFromBuildArtifact";
export const TestAX_FailuresReport = "VSO.TFS.TCM.TestAX_FailuresReport";
export const TestAX_PassRateCard = "VSO.TFS.TCM.TestAX_PassRateCard";
export const TestAX_FailedTestsCard = "VSO.TFS.TCM.TestAX_FailedTestsCard";
export const TestAX_FlakyTestsCard = "VSO.TFS.TCM.TestAX_FlakyTestsCard";
export const TestAX_AggregateTrendChart = "VSO.TFS.TCM.TestAX_AggregateTrendChart";
export const TestAX_ResultsGrid = "VSO.TFS.TCM.TestAX_ResultsGrid";
export const TestAX_ResultsGridLoadMore = "VSO.TFS.TCM.TestAX_ResultsGridLoadMore";
export const TestAX_ResultsGridElement = "VSO.TFS.TCM.TestAX_ResultsGridElement";
export const TestAX_TestTrendChart = "VSO.TFS.TCM.TestAX_TestTrendChart";
export const TestAX_TestHistoryGrid = "VSO.TFS.TCM.TestAX_TestHistoryGrid";
export const TestAX_TestHistoryGridLoadMore = "VSO.TFS.TCM.TestHistoryGridLoadMore";
export const TestAX_TestInsightsReport = "VSO.TFS.TCM.TestAX_TestInsightsReport";
